import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { RESTDataSource } from 'app/helpers/rest.datasource';
import { OfferIface } from 'app/interfaces/offer.iface';
import { OffersService } from 'app/services/offers.service';
import { AuthService } from 'app/services/auth.service';
import { Tag } from 'app/interfaces/tag';
import { ToastsManager } from 'ng2-toastr';
import { MatChipInputEvent } from '@angular/material';
import { Status } from 'app/interfaces/status';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-offers-tags-dialog',
  templateUrl: './mass-tags-change-dialog.component.html',
  styleUrls: ['./mass-tags-change-dialog.component.scss']
})
export class MassTagsChangeDialogComponent implements OnInit, OnDestroy {
  public dataSource: RESTDataSource<OfferIface>;
  public statusToChange: Status;
  public isLoadingResults = false;
  public customTags: Tag[] = [];
  private activeTags: Tag[] = [];
  private subscriptions: Subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<MassTagsChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private offersService: OffersService,
    private authService: AuthService,
    private toastr: ToastsManager,
    public translate: TranslateService
  ) {
    this.activeTags = data.activeTags;
    this.statusToChange = data.selectedStatus;
  }

  ngOnInit() {
    this.dataSource = new RESTDataSource(this.offersService);
    this.loadData();
  }

  loadData() {
    const query = this.createQuery();
    this.dataSource.loadData(query, 0, 0, 'status');
  }

  save(): void {
    this.isLoadingResults = true;
    const query = this.createQuery();
    this.offersService.massUpdate(query, 'updateTag').subscribe(
      () => {
        this.toastr.success(
          this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.SUCCESS'),
          this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.SUCCESS_TITLE')
        );
        this.isLoadingResults = false;
        this.dialogRef.close(true);
      },
      error => {
        this.isLoadingResults = false;
        if (error.status === 406) {
          this.toastr.error(
            error.error.error,
            this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.ERROR_TITLE')
          );
        } else {
          this.toastr.error(
            this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.ERROR'),
            this.translate.instant('OFFERS_LIST.MASS_STATUS_CHANGE.COMPONENT.ERROR_TITLE')
          );
        }
      }
    );
  }

  close() {
    this.dialogRef.close(false);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.customTags.push({ category: 'custom', value: value.trim() });
    }

    if (input) {
      input.value = '';
    }
  }

  remove(customTag: Tag): void {
    const index = this.customTags.map(tag => tag.value).indexOf(customTag.value);

    if (index >= 0) {
      this.customTags.splice(index, 1);
    }
  }

  private createQuery() {
    let query = {};
    const activeTags = this.activeTags.map(activeTag => activeTag.value);
    if (activeTags.length) {
      query = Object.assign(query, { 'tags.value': { $all: activeTags } });
    }
    if (this.customTags.length) {
      query = Object.assign(query, { customTags: this.customTags });
    }
    query = Object.assign(query, { offerStatus: this.statusToChange.statusCode });
    return query;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-list/mass-tags-change-dialog/mass-tags-change-dialog.component.ts